import React from "react";
import { Alert, Button, ButtonGroup, Modal } from "../ui";

const PriceWarningModal = ({ open, closeModal, type, onEdit, onConfirm }) => {
  const getMessage = () => {
    if (type === "chrono") {
      return 'Chrono24 listing price is set as "Price on request"';
    } else if (type === "ebay") {
      return 'eBay listing price is set as "1"';
    }
    return "";
  };

  const handleEdit = () => {
    onEdit();
    closeModal();
  };

  const handleConfirm = () => {
    onConfirm();
    closeModal();
  };

  return (
    <Modal
      open={open}
      onClose={closeModal}
      variant="dialog"
      size="sm"
      title="Check the listing price"
      footer={
        <ButtonGroup align="end">
          <Button variant="secondary" data-btn="listing-price-edit" onClick={handleEdit}>
            Edit
          </Button>
          <Button variant="primary" data-btn="listing-price-confirm" onClick={handleConfirm}>
            Confirm
          </Button>
        </ButtonGroup>
      }
    >
      <Alert tone="warning">{getMessage()}</Alert>
    </Modal>
  );
};

export default PriceWarningModal;
